<template>
  <div class="loading-bounce">
    <div class="child-bounce loading-bounce-1" :style="{ 'background-color': colorTypes[colorType] }"></div>
    <div class="child-bounce loading-bounce-2" :style="{ 'background-color': colorTypes[colorType] }"></div>
    <div class="child-bounce loading-bounce-3" :style="{ 'background-color': colorTypes[colorType] }"></div>
  </div>
</template>

<script>
export default {
  name: 'loading-bounce',

  data() {
    return {
      colorTypes: {
        primary: '#00c896',
        secondary: '#9013fe',
      },
    };
  },

  props: {
    colorType: {
      type: String,
      default: 'primary',
    },
  },
};
</script>
